import type { Color } from 'src/types/theme';

export const primary: Color = {
  50: '#a1a1a1',
  100: '#a1a1a1',
  200: '#a1a1a1',
  300: '#a1a1a1',
  400: '#a1a1a1',
  500: '#000000',
  600: '#000000',
  700: '#000000',
  800: '#000000',
  900: '#000000',
};
